import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { WorkingHourBuilder } from '../../models/builders/working-hour.builder';
import { WorkingHour } from '../../models/working-hour';
import { getUserLogged } from '../../utils/jwt.utils';
import { valueOf } from '../../utils/string.utils';
import { isArray } from 'util';
import { mapCollection } from '../../utils/collection.utils';

const workingHourBody = (workingHour: WorkingHour) => ({
  user: (workingHour.userHash) ? workingHour.userHash : getUserLogged(),
  hash: workingHour.hash,
  baseManufacturingOrder: workingHour.manufacturingOrder,
  userActivity: (workingHour.userActivity) ? workingHour.userActivity : '',
  userSubactivity: workingHour.userSubactivity,
  day: workingHour.day,
  totalTime: workingHour.totalTime,
  model: workingHour.modelHash,
  elementNumber: workingHour.erpTask,
  nonProductiveManufacturingOrderCategory: workingHour.nonProductiveManufacturingOrderCategoryHash,
  nonConformityCode: workingHour.nonConformityCode
});

const createValidationWorkingHoursBody = (validateWorkingHours: WorkingHour[]) => {
  const workingHours = (isArray(validateWorkingHours))
    ? mapCollection((workingHoursValidation: WorkingHour) => ({ hash: workingHoursValidation.hash })
        , validateWorkingHours
      )
    : [];

    return { workingHours };
};

@Injectable()
export class WorkingHourApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }workingHours`;
  }

  createWorkingHour(workingHour: WorkingHour) {
    return this.httpClient.post(this.apiUrl, workingHourBody(workingHour)).pipe(map(WorkingHourBuilder.fromJson));
  }

  deleteWorkingHours(workingHour: WorkingHour) {
    return this.httpClient.delete(`${ this.apiUrl }/${ workingHour.hash }`);
  }

  getWorkingHoursBetween(user: string, date: number) {
    const params = new HttpParams().append('user', user).append('date', date.toString());
    return this.httpClient.get(`${ this.apiUrl }/between/${ params }`).pipe(map(WorkingHourBuilder.fromList));
  }

  getWorkingHoursNow(user: string) {
    return this.httpClient.get(`${ this.apiUrl }/now/${ user }`).pipe(map(WorkingHourBuilder.fromList));
  }

  getWorkingHours(start: number, end: number) {
    const params = new HttpParams()
      .append('start', valueOf(start))
      .append('end', valueOf(end));

    return this.httpClient.get(`${ this.apiUrl }`, { params })
      .pipe(map(WorkingHourBuilder.fromList));
  }

  getWorkingHoursDay(date: number, user: string) {
    return this.httpClient.get(`${ this.apiUrl }/day${ date }/${ user }`).pipe(map(WorkingHourBuilder.fromList));
  }

  getWorkingHour(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`).pipe(map(WorkingHourBuilder.fromJson));
  }

  getWorkingHoursIn(hash: string, date: number) {
    const params = new HttpParams().append('user', hash).append('date', date.toString());
    return this.httpClient.get(`${ this.apiUrl }/${ params }`).pipe(map(WorkingHourBuilder.fromList));
  }

  updateWorkingHours(workingHour: WorkingHour) {
    return this.httpClient.put(`${ this.apiUrl }/${ workingHour.hash }`, workingHourBody(workingHour));
  }

  validateWorkingHours(workingHours: WorkingHour[]) {
    const body = createValidationWorkingHoursBody(workingHours);
    return this.httpClient.post(`${ this.apiUrl }/validate`, body);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/working-hour-api.service.ts